<!-- Start Follow-up Panel -->
<div class="modal-box-3">
  <h4 class="box-heading mb-0">
    Follow-ups
  </h4>

  <p-accordion styleClass="upcoming-follow-up estimate-accordion with-right-chevron" [multiple]="true">
    <p-accordionTab [selected]="upcomingFollowUps?.length">
      <p-header>
        <h2 class="accordion-trigger">
          Upcoming follow-ups ({{upcomingFollowUps?.length}})
        </h2>
      </p-header>

      <div class="accordian-empty-screen" *ngIf="!upcomingFollowUps?.length">
        There are no upcoming follow-ups for this vehicle
      </div>

      <div class="inner-accordion"
        *ngFor="let followUp of upcomingFollowUps | slice: 0 : (isAllVisible.upcomingFollowUp? upcomingFollowUps?.length : 2)">
        <app-dialog-follow-up-card [isMarketingOptOutEnabled]="isMarketingOptOutEnabled" [isScheduled]="true"
          [currentTime]="serverTime" [followUp]="followUp" (openContactUpdateDialog)="openContactUpdateDialog()"
          [customer]="customer" (appHandleOpenTemplate)="handleOpenTemplate($event)" (appGetFollowUp)="getFollowUp()">
        </app-dialog-follow-up-card>
        <p *ngIf="isMarketingOptOutEnabled && followUp?.unsubscribeCount === followUp?.contacts?.length"
          class="m-0 font-white bg-yellow flex-center-center blocked-label follow-up-extends">
          <i class="fal fa-exclamation-triangle pr-2"></i>
          <span>Follow-up blocked</span>
        </p>
      </div>

      <button class="view-less btn" *ngIf="upcomingFollowUps?.length > 2"
        (click)="isAllVisible.upcomingFollowUp = !isAllVisible.upcomingFollowUp">
        {{isAllVisible?.upcomingFollowUp? 'Show less': 'Show more'}}
      </button>
    </p-accordionTab>

    <p-accordionTab *ngIf="hasShowRecommended"
    [selected]="recommendedFollowUps?.length">
      <p-header>
        <h2 class="accordion-trigger">
          Recommended follow ups ({{recommendedFollowUps?.length}})
        </h2>
      </p-header>

      <div class="accordian-empty-screen" *ngIf="!recommendedFollowUps?.length">
        There are no recommended follow-ups for this vehicle
      </div>

      <div class="inner-accordion"
        *ngFor="let followUp of recommendedFollowUps | slice: 0 : (isRecommendedExpanded? recommendedFollowUps?.length : 2);">
        <app-dialog-follow-up-card [isMarketingOptOutEnabled]="isMarketingOptOutEnabled" [isCloseable]="false"
          [isDefaultOpen]="true" [currentTime]="serverTime" [followUp]="followUp" [customer]="customer"
          (appHandleOpenTemplate)="handleOpenTemplate($event)" (appGetFollowUp)="getFollowUp()"
          (openContactUpdateDialog)="openContactUpdateDialog()">
        </app-dialog-follow-up-card>
      </div>

      <p *ngIf="recommendedFollowUps?.length > 2"
        class="show-more-less-btn flex-center-center font-600 font-12 m-0 pointer p-1 mt-2"
        (click)="isRecommendedExpanded = !isRecommendedExpanded">
        {{isRecommendedExpanded? 'Show less' : 'Show more'}}
      </p>
    </p-accordionTab>

    <p-accordionTab>
      <p-header>
        <h2 class="accordion-trigger">
          Eligible follow ups ({{eligibleFollowUps?.length}})
        </h2>
      </p-header>

      <div class="accordian-empty-screen" *ngIf="!eligibleFollowUps?.length">
        There are no eligible follow-ups for this vehicle
      </div>

      <div class="inner-accordion"
        *ngFor="let followUp of eligibleFollowUps | slice: 0 : (isEligibleExpanded? eligibleFollowUps?.length : 2);">
        <app-dialog-follow-up-card [isMarketingOptOutEnabled]="isMarketingOptOutEnabled" [currentTime]="serverTime"
          [followUp]="followUp" [customer]="customer" (appHandleOpenTemplate)="handleOpenTemplate($event)"
          (appGetFollowUp)="getFollowUp($event)" (openContactUpdateDialog)="openContactUpdateDialog()">
        </app-dialog-follow-up-card>
      </div>

      <p *ngIf="eligibleFollowUps?.length > 2"
        class="show-more-less-btn flex-center-center font-600 font-12 m-0 pointer p-1 mt-2"
        (click)="isEligibleExpanded = !isEligibleExpanded">
        {{isEligibleExpanded? 'Show less' : 'Show more'}}
      </p>
    </p-accordionTab>
  </p-accordion>
</div>
<!-- End Follow-up Panel -->
